// extracted by mini-css-extract-plugin
export default {"user-link":"_2f0dA","userLink":"_2f0dA","link-banned":"_2-yK0","linkBanned":"_2-yK0"};